import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'readTime',
})
export class ReadTimePipe implements PipeTransform {
  transform(value: string = '', label = 'Minutes'): string {
    const parsed = parseInt(value);

    if (isNaN(parsed)) {
      return '';
    }

    return `${parsed} ${label}`;
  }
}
